import { Button, Input, Space, Form } from 'antd'
import TextArea from 'antd/es/input/TextArea'
import React, { useEffect } from 'react'
import {  useNavigate } from 'react-router'
import DropdownSelect from '../../../components/common/select'
import { useDispatch, useSelector } from 'react-redux'
import { listTenantFun } from '../../../redux/reducer/TenantSlice'
import { createNotification } from '../../../redux/reducer/NotificationSlice'
import { toast } from 'react-toastify'

const NotificationComp = () => {
   
    const [form] = Form.useForm();
    const navigate = useNavigate()
    const dispatch = useDispatch()

    const {listTenant,  listTenantLoading} = useSelector((prev) => prev?.tenant)
    const {notificationLoading} = useSelector((prev) => prev?.notification)

    useEffect(()=>{
        dispatch(listTenantFun())
    },[dispatch])

    const listTenantData = listTenant.map(
        ({ id, name_en }) => ({ label: name_en, value: id })
      );


    const onFinish = async (values) => {
      const payload = {...values,  broadcast: true,}
      try{  
        const response = await dispatch(createNotification(payload));
        if(response.payload.code === 201){
         toast.success(response?.payload?.message) 
         navigate(-1)
         form.resetFields();
       }
      }catch(e){
        console.log(e)
      }
    }

    const categoryTypeData = ["first", "second"]

  return (
    <>
     <div className="addBtnBx dflex">
        <div className="tableHeading">
          Send Notification
        </div>
       
      </div>
    <Form
      form={form}
      layout="vertical"
      onFinish={onFinish}
      style={{ maxWidth: 600, margin: "0" }}
    >
      <Form.Item
        label="Title"
        name="title"
        rules={[{ required: true, message: "Title is required" }]}
      >
        <Input placeholder="Enter title" />
      </Form.Item>

      <Form.Item
        label="Description"
        name="body"
        rules={[{ required: true, message: "Description is required" }]}
      >
        <TextArea rows={4} style={{height: "150px"}} placeholder="Enter description" />
      </Form.Item> 

                <Form.Item
                  name="user_id"
                  label="Select Specific Tenant"
                >
                  <DropdownSelect
                   mode="multiple"
                    // value={form.getFieldValue("category_type")}
                    // onChange={(value) => form.setFieldsValue({ category_type: value })}
                   options={listTenantData} placeholder="All" />
                </Form.Item>

      <Space>
          <Button type="primary" onClick={() => form.submit()} loading={notificationLoading}>
            Save Details
          </Button>
        </Space>

      </Form>
      </>

  )
}

export default NotificationComp